import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthProvider from './context/AuthContext';


import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/paginate.css';
import './styles/layout.css';
import 'react-nice-dates/build/style.css'
import './styles/camino.css'
import './App.css';
import './styles/small-devices.css';
import './fonts/fonts.css'
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <AuthProvider>
    <BrowserRouter><App /></BrowserRouter>    
  </AuthProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
